import InputCheck from './inputCheck'

export default InputCheck